import { useEffect, useState } from "react";
import { PACK_SLIP_SCREENS } from "../constants";
import {
  fetchPSStatusThunk,
  fetchPSValidateBoxThunk,
} from "../services/packslip.service";
import { message } from "antd";

export const usePackSlipData = (props) => {
  const { isOnline } = props;
  const access_token = localStorage.getItem("accessKey");
  const [screen, setScreen] = useState(PACK_SLIP_SCREENS.HOME);
  const [containerData, setContainerData] = useState(null);
  const [psData, setPsData] = useState(null);
  const [statusLoading, setStatusLoading] = useState(false);

  useEffect(() => {
    if (screen === PACK_SLIP_SCREENS.HOME && !containerData && isOnline) {
      setStatusLoading(true);
      fetchPSStatusThunk({
        next: (data, error) => {
          setStatusLoading(false);
          if (error) {
            message.error(error);
            setContainerData(null);
          } else if (data) {
            setContainerData(data);
          }
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [access_token, isOnline, containerData, screen]);

  const onSubmitContainer = async (boxNumber, sourceBox = true, resolve) => {
    if (isOnline) {
      setStatusLoading(true);
      await fetchPSValidateBoxThunk({
        boxNumber,
        sourceBox,
        next: (data, error) => {
          setStatusLoading(false);
          if (error) {
            message.error(error, 5);
            setPsData(null);
            resolve && resolve(false);
          } else if (data) {
            if (sourceBox) {
              message.success(data);
              resolve && resolve(true);
            } else {
              setPsData(data);
              setScreen(PACK_SLIP_SCREENS.ASSIGNED);
              resolve && resolve(true);
            }
          }
        },
      });
    }
    return false;
  };

  const toggleLoading = (value) => {
    setStatusLoading(value);
  };

  const setCustomScreen = (value) => {
    setScreen(value);
  };
  return {
    screen,
    containerData,
    psData,
    onSubmitContainer,
    toggleLoading,
    loaders: {
      statusLoading,
    },
    setPsData,
  };
};
